<template>
  <div class="host-item" @click="to">
    <div class="left">
      <!-- 头像区域 -->
      <van-image
        round
        width="1.2rem"
        height="1.2rem"
        use-error-slot
        use-loading-slot
        :src="headPortrait"
      >
        <van-loading slot="loading" type="spinner" size="20" vertical />
        <template slot="error">
          <van-image
            round
            width="1.2rem"
            height="1.2rem"
            src="https://pxsp.iceriverbj.com/default-avatar.png"
          ></van-image>
        </template>
      </van-image>
    </div>
    <div class="right">
      <span>
        <!-- 名称 -->
        <span class="name">{{ name == null ? "" : name }}</span>
        <!-- 职位 -->
        <span v-show="zw" class="zwBox">
          <span class="zw">{{ zw == null ? "" : zw }}</span></span
        >

      </span>
      <!-- 单位以及职务 -->
      <span class="position">{{ position }}</span>
      <p  class="remark" v-if="remark"> {{remark || ''}} </p>

    </div>
    <!-- 嘉宾按钮 -->
    <div class="detail" v-if="detail" @click="toProfile">嘉宾简介></div>
  </div>
</template>

<script>
export default {
  props: {
    // 嘉宾名称
    name: {
      type: String,
      default: "",
    },
    // 嘉宾id
    id: {
      type: Number,
      default: 0,
    },
    // 嘉宾单位
    position: {
      type: String,
      default: "",
    },
    // 头像
    headPortrait: {
      type: String,
      default: "https://pxsp.iceriverbj.com/default-avatar.png",
    },
    // 职务
    zw: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
    listData: {
      type: String,
      default: "",
    },
    // 是否是嘉宾简介页面
    detail: {
      type: Boolean,
      default: false,
    },
    // 是否是通知页面
    tongzhi: {
      type: Boolean,
      default: false,
    },
    // 日程id
    agenda_id: {
      type: String,
    },
    // 活动id
    event_id: {
      type: String,
    },
    // 日程会场筛选
    isAgenda: {
      type: String,
    },
    // 日程日期筛选
    date: {
      type: String,
    },
    // 当前日程日期
    currentDate: {
      type: String,
    },
    // 主页模式
    mode: {
      type: "",
      default: "",
    },
  },
  methods: {
    to() {
      // 如果不是嘉宾简介和日程通知页面再跳转
      if (!this.detail && !this.tongzhi) {
        this.$router.push(
          `/subpages/guestAgenda?agenda_id=${this.agenda_id}&id=${this.id}&event_id=${this.event_id}&isAgenda=${this.isAgenda}&date=${this.date}&currentDate=${this.currentDate}&mode=${this.mode}${this.listData}`
        );
      }
    },

    // 嘉宾简介按钮回调
    toProfile() {
      // 如果是通知界面
      if (this.tongzhi) {
        this.$router.push(`/guestDetail?id=${this.id}&event_id=${this.event_id}`);
      } else {
        console.log(123);
        // 如果不是通知界面
        this.$router.push(
          `/subpages/guestAgenda/guestProfile?id=${this.id}&agenda_id=${this.agenda_id}&event_id=${this.event_id}&isAgenda=${this.isAgenda}&date=${this.date}&currentDate=${this.currentDate}&mode=${this.mode}${this.listData}`
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.host-item {
  position: relative;
  width: 100%;
  margin-top: 10px;
  display: flex;
  .left {
    display: flex;
    align-items: center;
  }

  .right {
    width: 100%;
    display: flex;
    padding: 0.2rem 0 0.2rem 0;
    margin-left: 0.3rem;
    flex-direction: column;
    justify-content: space-between;
    span {
      &:nth-child(1) {
        font-size: 0.4rem;
        color: #555454;
        display: flex;
        align-items: center;
        .name {
          line-height: 100%;
          max-width: 4em;
          flex: none;
        }
        .zwBox {
          margin-left: 0.1rem;
          padding: 0 0.1rem;
          border: 1px solid #409eff;
          border-radius: 0.2rem;

          .zw {
            white-space: nowrap;
            height: 0.4rem;
            color: #409eff;
            font-size: 0.22rem;
            line-height: 0.39rem;
          }
        }
      }
    }
    .position {
      font-size: 0.3rem;
      color: #8a8a8a;
      vertical-align: middle;
      margin-top: 10px;

    }
  }
  .detail {
    position: absolute;
    color: #409eff;
    right: 5%;
    top: 1%;
  }
}

.remark {
    font-size: 0.3rem;
    margin-left: .1rem;
    color: #acaaaa;
    line-height: 100%;
    padding: 0;
    margin: 0;
    margin-top: 10px;
}
</style>
